import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { map } from "rxjs/operators";
import { AuthService } from "./auth.service";
import { BehaviorSubject, Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";
@Injectable({
  providedIn: "root",
})
export class ParentService {
  selectedParentChild = new BehaviorSubject(null);
  triggerSelectedParentChildSync = new Subject();
  constructor(
    public db: AngularFirestore,
    public auth: AuthService,
    private toastr: ToastrService
  ) {}

  getParentDocData() {
    let uid: any = localStorage.getItem("uid");
    return this.db
      .collection("Parents")
      .doc(uid)
      .snapshotChanges()
      .pipe(
        map((actions) => {
          let data: any = actions.payload.data();
          return { ...{ id: actions.payload.id }, ...data };
        })
      );
  }

  getChildData(id: any) {
    return this.db
      .collection("Children")
      .doc(id)
      .snapshotChanges()
      .pipe(
        map((actions) => {
          let data: any = actions.payload.data();
          return { ...{ id: actions.payload.id }, ...data };
        })
      );
  }

  async addAnotherChildForLiveLocation(
    email: any,
    childId: any,
    deviceId: any
  ) {
    try {
      let res: any = await this.db
        .collection("Location")
        .doc(`${childId}_${deviceId}`)
        .get()
        .pipe(
          map((actions) => {
            return actions.data();
          })
        )
        .toPromise();
      if (res) {
        let sharedWith = [];
        if (res.sharedWith) {
          sharedWith = res.sharedWith;
        }
        if (!sharedWith.includes(email)) {
          sharedWith.push(email);
          this.db
            .collection("Location")
            .doc(`${childId}_${deviceId}`)
            .update({ sharedWith: sharedWith });
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  }

  async removeSharedWithEmail(email: any, childId: any, deviceId: any) {
    try {
      let res: any = await this.db
        .collection("Location")
        .doc(`${childId}_${deviceId}`)
        .get()
        .pipe(
          map((actions) => {
            return actions.data();
          })
        )
        .toPromise();
      if (res) {
        let sharedWith = [];
        if (res.sharedWith) {
          sharedWith = res.sharedWith;
        }
        if (sharedWith.includes(email)) {
          sharedWith.splice(sharedWith.indexOf(email), 1);
          this.db
            .collection("Location")
            .doc(`${childId}_${deviceId}`)
            .update({ sharedWith: sharedWith });
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  }

  getSharedLocationDoc() {
    return this.db
      .collection("sharedLiveLocations")
      .doc(this.auth.getUserId())
      .valueChanges();
  }

  getDeviceData(childId: any, deviceId: any, selectedDate: any) {
    let month: any = new Date(selectedDate).getMonth() + 1;
    let date: any = new Date(selectedDate).getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (date < 10) {
      date = "0" + date;
    }
    let docId =
      childId +
      "_" +
      deviceId +
      "_" +
      new Date(selectedDate).getFullYear() +
      "-" +
      month +
      "-" +
      date;
    return this.db
      .collection("DeviceUsageStatistics")
      .doc(docId)
      .get()
      .pipe(
        map((actions) => {
          let data: any = actions.data();
          return { ...{ id: actions.id }, ...data };
        })
      );
  }

  getDeviceAppDetails(childId: any, deviceId: any) {
    let docId = childId + "_" + deviceId;
    return this.db
      .collection("AppBlock")
      .doc(docId)
      .get()
      .pipe(
        map((actions) => {
          let data: any = actions.data();
          return { ...{ id: actions.id }, ...data };
        })
      );
  }

  getPermissionDetails(childId: any, deviceId: any) {
    let docId = childId + "_" + deviceId;
    return this.db
      .collection("PermissionStatus")
      .doc(docId)
      .get()
      .pipe(
        map((actions) => {
          let data: any = actions.data();
          return { ...{ id: actions.id }, ...data };
        })
      );
  }

  getDeviceContactDetails(childId: any, deviceId: any) {
    let docId = childId + "_" + deviceId;
    return this.db
      .collection("Contact")
      .doc(docId)
      .get()
      .pipe(
        map((actions) => {
          let data: any = actions.data();
          return { ...{ id: actions.id }, ...data };
        })
      );
  }

  getDeviceCallLogsDetails(childId: any, deviceId: any) {
    let docId = childId + "_" + deviceId;
    return this.db
      .collection("Call_Log")
      .doc(docId)
      .get()
      .pipe(
        map((actions) => {
          let data: any = actions.data();
          return { ...{ id: actions.id }, ...data };
        })
      );
  }

  

  getDeviceSmsDetails(childId: any, deviceId: any) {
    let docId = childId + "_" + deviceId;
    return this.db
      .collection("SMS")
      .doc(docId)
      .get()
      .pipe(
        map((actions) => {
          let data: any = actions.data();
          return { ...{ id: actions.id }, ...data };
        })
      );
  }

  getDeviceUsageStatisticsDetails(childId: any, deviceId: any) {
    let docId = childId + "_" + deviceId;
    return this.db
      .collection("DeviceUsageStatistics")
      .doc(docId)
      .get()
      .pipe(
        map((actions) => {
          let data: any = actions.data();
          return { ...{ id: actions.id }, ...data };
        })
      );
  }
  getLocationDetails(childId: any, deviceId: any) {
    let docId = childId + "_" + deviceId;
    return this.db
      .collection("Location")
      .doc(docId)
      .get()
      .pipe(
        map((actions) => {
          let data: any = actions.data();
          return { ...{ id: actions.id }, ...data };
        })
      );
  }

  saveDeviceAppData(childId: any, deviceId: any, data: any) {
    let docId = childId + "_" + deviceId;
    return this.db.collection("AppBlock").doc(docId).update(data);
  }

  getLocationLogs(childId: any, deviceId: any, date: any) {
    let docId = childId + "_" + deviceId;
    let nextDate = new Date(date);
    let previousDate = new Date(date);
    previousDate.setHours(0, 0, 0, 0);
    nextDate.setHours(23, 59, 59, 999);
    // nextDate.setDate(nextDate.getDate() + 1);
    // previousDate.setDate(previousDate.getDate() - 1);
    return this.db
      .collection("Location")
      .doc(docId)
      .collection("Locationlogs", (ref) =>
        ref
          .where("timestamp", "<", nextDate)
          .where("timestamp", ">", previousDate)
          .orderBy("timestamp", "desc")
      )
      .snapshotChanges()
      .pipe(
        map((actions: any) =>
          actions.map((a: any) => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          })
        )
      );
  }

  getLocationData(childId: any, deviceId: any) {
    let docId = childId + "_" + deviceId;
    return this.db
      .collection("Location")
      .doc(docId)
      .snapshotChanges()
      .pipe(
        map((actions) => {
          let data: any = actions.payload.data();
          return { ...{ id: actions.payload.id }, ...data };
        })
      );
  }

  getMoodLogs(childId: any, deviceId: any, selectedDate: any) {
    let docId = childId + "_" + deviceId;
    let nextDate = new Date(selectedDate);
    let previousDate = new Date(selectedDate);
    nextDate.setMonth(nextDate.getMonth() + 1);
    nextDate.setDate(0);
    previousDate.setDate(1);
    return this.db
      .collection("moodLogs")
      .doc(docId)
      .collection("moodLogs", (ref) =>
        ref
          .where("dateTime", "<", nextDate)
          .where("dateTime", ">", previousDate)
      )
      .snapshotChanges()
      .pipe(
        map((actions: any) =>
          actions.map((a: any) => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          })
        )
      );
  }

  getSharedLiveLocations(email: any) {
    return this.db
      .collection("Location", (ref) =>
        ref.where("sharedWith", "array-contains", email)
      )
      .valueChanges();
  }

  setParentChild(data) {
    this.selectedParentChild.next(data);
    localStorage.setItem("selectedParentChild", JSON.stringify(data));
  }

  showToast(type, title, message) {
    if (type == "success") {
      this.toastr.success(title, message);
    }
    if (type == "error") {
      this.toastr.error(title, message);
    }
  }

  getDevicePermissionsStatus(childid, deviceid) {}
}
